
(function () {
  "use strict";

  var root = document.querySelector(".secret-sale-page");
  if (!root) return;

  var GOOGLE_SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycby7DmSS-t3TjGmcFXQFwDlv9TnnWBa-Q_MUj6-nBynZaDgIbnNSMMoQphrcCMXyZiwWgg/exec";

  var START = new Date("2026-10-31T00:00:00+01:00").getTime();
  var END = new Date("2026-11-01T23:59:59+01:00").getTime();

  var box = root.querySelector(".cds");
  var lab = root.querySelector(".cdw .lab");
  var vals = box ? box.querySelectorAll(".cd b") : [];

  function pad(n) {
    return (n < 10 ? "0" : "") + n;
  }

  function tick() {
    var now = Date.now();

    if (now >= END) {
      if (lab) lab.textContent = "Der VIP Sale ist beendet.";
      if (box) box.style.display = "none";
      return;
    }

    var target = START;

    if (now >= START) {
      target = END;
      if (lab) {
        lab.textContent = "Der Sale läuft! Endet in:";
        lab.classList.add("live");
      }
    }

    var total = Math.max(0, Math.floor((target - now) / 1000));
    var v = [
      Math.floor(total / 86400),
      Math.floor((total % 86400) / 3600),
      Math.floor((total % 3600) / 60),
      total % 60
    ];

    for (var i = 0; i < vals.length; i++) {
      vals[i].textContent = pad(v[i]);
    }
  }

  tick();
  window.setInterval(tick, 1000);

  // Save registration to Google Sheets.
  function saveRegistration(email, submissionId) {
    var payload = new URLSearchParams({
      email: email,
      page_url: window.location.href.split("?")[0],
      submission_id: submissionId
    });

    return fetch(GOOGLE_SCRIPT_URL, {
      method: "POST",
      mode: "no-cors",
      body: payload,
      keepalive: true
    }).catch(function (error) {
      console.error("[Secret Sale] Google Sheets logging failed:", error);
    });
  }

  root.querySelectorAll("[data-secret-sale-form]").forEach(function (form) {
    form.addEventListener("submit", async function (event) {
      event.preventDefault();

      var message = form.querySelector("[data-form-message]");
      var button = form.querySelector('button[type="submit"]');
      var key = root.getAttribute("data-klaviyo-key");
      var listId = root.getAttribute("data-klaviyo-list");

      var emailInput = form.elements.email;
      var consentInput = form.elements.email_consent;

      var email = emailInput
        ? String(emailInput.value || "").trim().toLowerCase()
        : "";

      var consent = !!(consentInput && consentInput.checked);

      if (
        !email ||
        !emailInput.checkValidity() ||
        !consent
      ) {
        if (message) {
          message.className = "ss-form-message is-error";
          message.textContent =
            "Bitte geben Sie eine gültige E-Mail-Adresse ein und stimmen Sie dem E-Mail-Marketing zu.";
        }
        return;
      }

      if (!key || !listId) {
        if (message) {
          message.className = "ss-form-message is-error";
          message.textContent =
            "Die Anmeldung ist noch nicht konfiguriert. Bitte versuchen Sie es später erneut.";
        }
        return;
      }

      if (button) {
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
      }

      if (message) {
        message.className = "ss-form-message";
        message.textContent = "Ihre Anmeldung wird verarbeitet …";
      }

      var submissionId =
        window.crypto && typeof window.crypto.randomUUID === "function"
          ? window.crypto.randomUUID()
          : "vip-" + Date.now() + "-" +
            Math.random().toString(36).slice(2, 12);

      var payload = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Thomsen VIP Secret Sale landing page",
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                  properties: {
                    vip_submission_id: submissionId,
                    vip_page_url: window.location.href.split("?")[0]
                  },
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: "SUBSCRIBED"
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId
              }
            }
          }
        }
      };

      try {
        var response = await fetch(
          "https://a.klaviyo.com/client/subscriptions/?company_id=" +
            encodeURIComponent(key),
          {
            method: "POST",
            headers: {
              accept: "application/vnd.api+json",
              "content-type": "application/vnd.api+json",
              revision: "2026-07-15"
            },
            body: JSON.stringify(payload)
          }
        );

        if (response.status === 202 || response.ok) {
          // Log only after Klaviyo accepts the subscription request.
          await saveRegistration(email, submissionId);

          window.location.assign(
            "/pages/secret-sale-bestaetigung"
          );
          return;
        }

        var detail = "";

        try {
          var err = await response.json();
          detail = err?.errors?.[0]?.detail || "";
        } catch (_) {}

        if (message) {
          message.className = "ss-form-message is-error";
          message.textContent =
            "Die Anmeldung konnte nicht abgeschlossen werden. " +
            (detail || "Bitte versuchen Sie es erneut.");
        }

      } catch (error) {
        console.error("[Secret Sale] Submission failed:", error);

        if (message) {
          message.className = "ss-form-message is-error";
          message.textContent =
            "Verbindungsfehler. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.";
        }

      } finally {
        if (button) {
          button.disabled = false;
          button.removeAttribute("aria-busy");
        }
      }
    });
  });

  root.querySelectorAll(".tabs span").forEach(function (tab) {
    tab.addEventListener("click", function () {
      root.querySelectorAll(".tabs span").forEach(function (item) {
        item.classList.remove("on");
      });

      tab.classList.add("on");
    });
  });
})();
